import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ items, className }) => {
  return (
    <nav className={`text-sm dark:text-grey text-info font-semibold ${className}`}>
      <ol className="list-reset flex">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className="flex items-center">
              {!isLast ? (
                <>
                  {item.onClick ? (
                    <span
                      className="hover:underline cursor-pointer"
                      onClick={item.onClick}
                    >
                      {item.label}
                    </span>
                  ) : item.path ? (
                    <Link to={item.path} className="hover:underline">
                      {item.label}
                    </Link>
                  ) : (
                    <span>{item.label}</span>
                  )}
                  <span className="mx-2">{">"}</span>
                </>
              ) : (
                <span className="text-lightPrimary dark:text-primary-gradient font-bold">
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};


export default Breadcrumb;
